import { render, staticRenderFns } from "./SaleRank.vue?vue&type=template&id=63823c57&scoped=true"
import script from "./SaleRank.vue?vue&type=script&lang=js"
export * from "./SaleRank.vue?vue&type=script&lang=js"
import style0 from "./SaleRank.vue?vue&type=style&index=0&id=63823c57&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63823c57",
  null
  
)

export default component.exports